module.exports = __webpack_public_path__ + "static/img/product06.930ac6b2.png";